import { Pie, ResponsivePie } from "@nivo/pie"
import { PieChartData } from "./PieChartColorFromData"

const PieChartForSLA = ({data, width, height}: {data:PieChartData[], width:number | undefined, height:number | undefined}) => {
    const isAllZeros = data.every(entry => entry.value === 0)
    let displayData = data

    if (isAllZeros) {
        displayData = [{id: "100%", label: "100%", value: 1, color: "rgb(147 183 83)"},
            {id: "SLA", label: "SLA", value: 0, color: "rgb(249 115 22)"}]
    }

    return (
        <div className="flex justify-center items-center place-self-center relative" style={{ minWidth: '120px', minHeight: '120px' }}>
            <div className="absolute flex justify-center items-center z-10 pointer-events-none">
                <div className="font-medium">
                    {displayData.find(d => d.id !== "SLA" && d.id !== "0%" && d.value > 0)?.id || ""}
                </div>
            </div>
                {
                    width && height ? 
                    <Pie
                        data={displayData}
                        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                        innerRadius={0.7}
                        padAngle={0.7}
                        cornerRadius={2}
                        activeOuterRadiusOffset={8}
                        colors={{ datum: "data.color" }}
                        enableArcLabels={false}
                        arcLabel={(data) => (data.value > 0 ? `${data.value}` : "")}
                        enableArcLinkLabels={false}
                        arcLinkLabelsTextColor="#000000"
                        arcLinkLabelsThickness={0}
                        arcLinkLabelsOffset={-80}
                        width={width}
                        height={height}                
                    />
                    : 
                     <ResponsivePie
                        data={displayData}
                        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                        innerRadius={0.7}
                        padAngle={0.7}
                        cornerRadius={2}
                        activeOuterRadiusOffset={8}
                        colors={{ datum: "data.color" }}
                        enableArcLabels={false}
                        arcLabel={(data) => (data.value > 0 ? `${data.value}` : "")}
                        enableArcLinkLabels={false}
                        arcLinkLabelsTextColor="#000000"
                        arcLinkLabelsThickness={0}
                        arcLinkLabelsOffset={-80}              
                    />
                }
        </div>
    )
}

export default PieChartForSLA